(function ($, Drupal) {
  Drupal.behaviors.polygonTooltip = {
    attach: function (context) {
      once('polygonTooltip', 'html', context).forEach(() => {
        function createTooltipFloor(
          floorTitle,
          interier,
          exterier,
          exterierLabel,
          available,
          preReserved,
          sold,
        ) {
          const tooltip = document.createElement('div');
          tooltip.className = 'polygon-tooltip';
          let innerHTML = `<p class="p-small !mb-2 text-gray-10">${floorTitle}</p><hr/>`;
          if (interier) {
            innerHTML += `
              <p class="!mb-0 flex justify-between">
                <span>${Drupal.t('Interior', {}, { context: 'ganzhouse' })}</span>
                <span class="pl-6 font-bold flex">${interier} m²</span>
              </p>`;
          }
          if (exterier) {
            const label = exterierLabel || Drupal.t('Exterior', {}, { context: 'ganzhouse' });
            innerHTML += `
              <p class="!mb-0 flex justify-between">
                <span>${label}</span>
                <span class="pl-6 font-bold flex">${exterier} m²</span>
              </p>`;
          }
          if (available) {
            innerHTML += `
              <p class="!mb-0 flex justify-between">
                <span>${Drupal.t('Free flats', {}, { context: 'ganzhouse' })}</span>
                <span class="pl-6 font-bold flex">${available}</span>
              </p>`;
          }
          if (preReserved) {
            innerHTML += `
              <p class="!mb-0 flex justify-between">
                <span>${Drupal.t('Prereserved flats', {}, { context: 'ganzhouse' })}</span>
                <span class="pl-6 font-bold flex">${preReserved}</span>
              </p>`;
          }
          if (sold) {
            innerHTML += `
              <p class="!mb-0 flex justify-between">
                <span>${Drupal.t('Sold flats', {}, { context: 'ganzhouse' })}</span>
                <span class="pl-6 font-bold flex">${sold}</span>
              </p>`;
          }
          tooltip.innerHTML = innerHTML;
          return tooltip;
        }

        function buildFloorDesktopTooltip(
          floorTitle,
          interier,
          exterier,
          exterierLabel,
          available,
          preReserved,
          sold,
        ) {
          return createTooltipFloor(
            floorTitle,
            interier,
            exterier,
            exterierLabel,
            available,
            preReserved,
            sold,
          );
        }

        function createTooltipFlat(flatName, rooms, interier, exterier, status, exterierLabel) {
          const tooltip = document.createElement('div');
          tooltip.className = 'polygon-tooltip';
          let innerHTML = `<p class="!mb-2 flex justify-between">
            <span class="font-bold">${flatName}</span>
            <span class="font-bold pl-6 flex">${status}</span>
          </p><hr/>`;
          if (rooms) {
            innerHTML += `
              <p class="!mb-0 flex justify-between">
                <span>${Drupal.t('Rooms', {}, { context: 'ganzhouse' })}</span>
                <span class="pl-6 font-bold flex">${rooms}</span>
              </p>`;
          }
          if (interier) {
            innerHTML += `
              <p class="!mb-0 flex justify-between">
                <span>${Drupal.t('Interior', {}, { context: 'ganzhouse' })}</span>
                <span class="pl-6 font-bold flex">${interier} m²</span>
              </p>`;
          }
          if (exterier) {
            const label = exterierLabel || Drupal.t('Exterior', {}, { context: 'ganzhouse' });
            innerHTML += `
              <p class="!mb-0 flex justify-between">
                <span>${label}</span>
                <span class="pl-6 font-bold flex">${exterier} m²</span>
              </p>`;
          }
          tooltip.innerHTML = innerHTML;
          return tooltip;
        }

        function attachTooltip(polygon, createTooltipFunc) {
          let tooltip;
          polygon.addEventListener('mouseenter', () => {
            const floorTitle = polygon.getAttribute('data-floornumber') || '';
            const interier = polygon.getAttribute('data-interier') || '';
            const exterier = polygon.getAttribute('data-exterier') || '';
            const exterierLabel = polygon.getAttribute('data-exterier-label') || '';
            const available = polygon.getAttribute('data-available') || '';
            const preReserved = polygon.getAttribute('data-prereserved') || '';
            const sold = polygon.getAttribute('data-sold') || '';
            tooltip = createTooltipFunc(
              floorTitle,
              interier,
              exterier,
              exterierLabel,
              available,
              preReserved,
              sold,
            );
            if (!tooltip) return;
            document.body.appendChild(tooltip);
          });

          polygon.addEventListener('mousemove', (event) => {
            if (!tooltip) return;
            const offset = 10;
            let left = event.pageX + offset;
            let top = event.pageY - tooltip.offsetHeight - offset;
            const maxLeft = window.innerWidth - tooltip.offsetWidth - 10;
            const maxTop = window.scrollY + window.innerHeight - tooltip.offsetHeight - 10;
            if (left > maxLeft) left = maxLeft;
            if (top < window.scrollY) top = event.pageY + offset;
            if (top > maxTop) top = maxTop;
            tooltip.style.left = `${left}px`;
            tooltip.style.top = `${top}px`;
          });

          polygon.addEventListener('mouseleave', () => {
            if (tooltip) {
              tooltip.remove();
              tooltip = null;
            }
          });
        }

        // Selects sa dopĺňajú VŽDY
        const floorSelect = document.querySelector('#floor-select');
        const flatSelect = document.querySelector('#flat-select');
        const floorTooltipContainer = document.querySelector('#floor-tooltip-container');
        const flatTooltipContainer = document.querySelector('#flat-tooltip-container');

        const floorPolygons = document.querySelectorAll('.floor-plan polygon');
        if (floorSelect && floorPolygons.length > 0) {
          floorSelect.innerHTML = `<option value="">${Drupal.t('- None -', {}, { context: 'ganzhouse' })}</option>`;
          floorPolygons.forEach((polygon, i) => {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = polygon.getAttribute('data-floornumber') || `Floor ${i + 1}`;
            option.setAttribute('data-floornumber', polygon.getAttribute('data-floornumber') || '');
            option.setAttribute('data-interier', polygon.getAttribute('data-interier') || '');
            option.setAttribute('data-exterier', polygon.getAttribute('data-exterier') || '');
            option.setAttribute('data-exterier-label', polygon.getAttribute('data-exterier-label') || '');
            option.setAttribute('data-available', polygon.getAttribute('data-available') || '');
            option.setAttribute('data-prereserved', polygon.getAttribute('data-prereserved') || '');
            option.setAttribute('data-sold', polygon.getAttribute('data-sold') || '');
            floorSelect.appendChild(option);
          });

          floorSelect.addEventListener('change', () => {
            const selected = floorSelect.selectedOptions[0];
            if (!selected || selected.value === '') {
              floorTooltipContainer.innerHTML = '';
              return;
            }
            const floorTitle = selected.textContent || '';
            const interier = selected.getAttribute('data-interier') || '';
            const exterier = selected.getAttribute('data-exterier') || '';
            const exterierLabel = selected.getAttribute('data-exterier-label') || '';
            const available = selected.getAttribute('data-available') || '';
            const preReserved = selected.getAttribute('data-prereserved') || '';
            const sold = selected.getAttribute('data-sold') || '';
            const tooltip = createTooltipFloor(
              floorTitle,
              interier,
              exterier,
              exterierLabel,
              available,
              preReserved,
              sold,
            );
            floorTooltipContainer.innerHTML = '';
            floorTooltipContainer.appendChild(tooltip);
          });
        }

        const flatPolygons = document.querySelectorAll('.flat-plan polygon');
        if (flatSelect && flatPolygons.length > 0) {
          flatSelect.innerHTML = `<option value="">${Drupal.t('- None -', {}, { context: 'ganzhouse' })}</option>`;
          flatPolygons.forEach((polygon, i) => {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = polygon.getAttribute('data-flatname') || `Flat ${i + 1}`;
            option.setAttribute('data-flatname', polygon.getAttribute('data-flatname') || '');
            option.setAttribute('data-rooms', polygon.getAttribute('data-rooms') || '');
            option.setAttribute('data-interier', polygon.getAttribute('data-interier') || '');
            option.setAttribute('data-exterier', polygon.getAttribute('data-exterier') || '');
            option.setAttribute('data-status', polygon.getAttribute('data-status') || '');
            option.setAttribute('data-exterier-label', polygon.getAttribute('data-exterier-label') || '');
            flatSelect.appendChild(option);
          });

          flatSelect.addEventListener('change', () => {
            const selected = flatSelect.selectedOptions[0];
            if (!selected || selected.value === '') {
              flatTooltipContainer.innerHTML = '';
              return;
            }
            const tooltip = createTooltipFlat(
              selected.getAttribute('data-flatname') || 'Unknown',
              selected.getAttribute('data-rooms') || '',
              selected.getAttribute('data-interier') || '',
              selected.getAttribute('data-exterier') || '',
              selected.getAttribute('data-status') || 'Unknown',
              selected.getAttribute('data-exterier-label') || '',
            );
            flatTooltipContainer.innerHTML = '';
            flatTooltipContainer.appendChild(tooltip);
          });
        }

        // Tooltipy na desktop
        const isMobile = window.matchMedia('(max-width: 976px)').matches;
        if (!isMobile) {
          floorPolygons.forEach((polygon) => {
            attachTooltip(polygon, buildFloorDesktopTooltip);
          });
          flatPolygons.forEach((polygon) => {
            attachTooltip(polygon, () => createTooltipFlat(
              polygon.getAttribute('data-flatname') || 'Unknown',
              polygon.getAttribute('data-rooms') || '',
              polygon.getAttribute('data-interier') || '',
              polygon.getAttribute('data-exterier') || '',
              polygon.getAttribute('data-status') || 'Unknown',
              polygon.getAttribute('data-exterier-label') || '',
            ));
          });
        }
      });
    },
  };
}(jQuery, Drupal));
